<template>
  <div class="teachCenter teachDetail">
    <!--面包屑-->
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
      <span>首页</span>>
      <span><router-link :to="{name:'TeachCenter'}">教学中心</router-link></span> >
      <span>医生课程</span>
    </div>
    <div class="hospital-select">
      <div class="docBrief">
          <img class="iconfont icon-touxiang" v-if="famousData.photoUrl!== undefined" :src="famousData.photoUrl" alt="">
          <img class="iconfont icon-touxiang" v-else src="../../../../static/image/user.png" alt="">
        <div class="rtBrief">
          <ul>
            <li>
              <span class="nameColor">{{famousData.name}}</span>
              <span>{{famousData.professionTitle}}</span>
            </li>
            <li class="difSecond">
              <div class="hospitalName">{{famousData.hospitalName}}</div>
            </li>
            <li>
              <p v-if="famousData.doctorDesc!==undefined" class="spilOmit" :title="famousData.doctorDesc">{{changedoctorDesc}}</p>
              <p v-else class="spilOmit">当前医生暂时没有相关介绍哦</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="rtNumber">
        <ul>
          <li class="borRight">
            <p v-if="famousData.courseCount!==undefined" class="amount">{{famousData.courseCount}}</p>
            <p v-else class="amount">0</p>
            <p>课程数量</p>
          </li>
          <li>
            <p v-if="famousData.lookNumber!==undefined" class="amount">{{famousData.lookNumber}}</p>
            <p v-else class="amount">0</p>
            <p>学习人次</p>
          </li>
        </ul>
      </div>
    </div>
    <!--列表-->
    <teachCard :tecahCardList="tecahCardList"  @popShow="routerShow1"></teachCard>
    <!--分页-->
    <page :total="page.total" :allPage="page.allPage" :currentPage="page.currentPage" @current-page="__currentPage"
          @page-size="__pageSize" :current="'tenchCenter'" :pageSize2="page.pageSize"></page>

  </div>
</template>

<script type="text/ecmascript-6">
  import teachCard from '@/components/common/card/teachCard'
  import page from '@/components/common/page/page'
  import router from '../../../../router'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  export default {
    components: {
      teachCard,
      page
    },
    data() {
      return {
        famousData: [],
        tecahCardList: [],
        changedoctorDesc:'',
        page: {
          currentPage: 1,
          pageSize: 20,
          total: 20,
          allPage: 0
        }
      }
    },
    mounted() {
    },
    updated() {
      this.maxSlice(this.famousData.doctorDesc)
    },
    methods: {
      maxSlice(val){
        let lent = val.length
        if(lent!=  undefined && lent > 95){
          let slicedTxt = val.slice(0,96) + '...'
          this.changedoctorDesc = slicedTxt
        }else{
          this.changedoctorDesc =  val
        }
      },
      routerShow1(){
        // alert(this.popShow)
        this.popShow = true
        this.$router.push({name: 'CourseEvaluat'})
      },
      famousVal(){  //详情接口数据
        let doctorId = getLocalStorage('famousId')
        let params = {
          teacherId: doctorId,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        }
        http.post('/studyCenter/getCourseListByDoctor.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.famousData = res.data.model
            this.tecahCardList = this.famousData.courseList
            this.page.total = this.famousData.courseCount

           let p = {
              typeId:'EDU_DOCTORTITLE'
            }
            http.post('/system/queryEduContantByTypeId.json', p).then(res => {
              if (res.data.code === _.ERR_OK) {

                   for(let i of res.data.model){
                    if(this.famousData.professionTitle == i.consId){
                      this.famousData.professionTitle = i.consDesc
                    }else if(this.famousData.professionTitle === undefined){
                      this.famousData.professionTitle = ''
                    }
                   }
              }
            })

          } else {

          }
        })
      },
      __currentPage(payload) { //选择页数
        this.page.currentPage = payload
        this.famousVal()
      },
      __pageSize(payload) {  //选择每页多少条
        this.page.pageSize = payload
        this.famousVal()
      },

    },
    created() {
      this.famousVal()
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .teachDetail
     .hospital-select
        width: 100%
        padding: 12px 30px
        height: 160px
        box-sizing: border-box
        margin-bottom: 8px
       .docBrief
          width: 70%
          height: 100%
          float: left
          overflow: hidden
          img
            width: 86px
            height: 86px
            border-radius: 50%
            overflow: hidden
            margin: 25px 30px 0 0
            float: left
          .rtBrief
            width: calc(100% - 116px)
            float: left
            margin-top 10px
            ul
              li
                margin: 12px 0
                span
                  color: #000
                .nameColor
                  margin-right: 20px
                  color $color-green
                  font-size: 16px
                  font-weight: bold
                .hospitalName
                  color: #000
              .difSecond
                 margin-top: 20px
        .rtNumber
          float: right
          width: 25%
          max-width: 280px
          height: 100%
          ul
            height: 100%
            overflow: hidden
            li
              width: 49%
              float: left
              height: 80px
              margin-top: 28px
              p
                text-align: center
              .amount
                font-size: 25px
                color: $color-green
                margin: 10px 0 25px
            .borRight
              border-right: 1px solid #ccc
</style>



// WEBPACK FOOTER //
// TeachDetail.vue?d7e66006